// extracted by mini-css-extract-plugin
export var divider = "_3r-0";
export var dividerText = "_3r-1";